<div>
    <div class="row mt-2">
        <div class="col-md-3">
            <label class="form-label">Category</label>
            <div class="form-group">
                <select class="form-select shadow-none" [(ngModel)]="strategyParams.category" disabled="true">
                    <option *ngFor="let category of categories" [value]="category.name"> {{ category.name }}</option>
                </select>
            </div>
        </div>
        <div class="col-md-3">
            <label class="form-label">Segment</label>
            <div class="form-group">
                <select class="form-select shadow-none" [(ngModel)]="strategyParams.segment" disabled="true">
                    <option *ngFor="let s of segments" [value]="s.name"> {{ s.name }}</option>
                </select>
            </div>
        </div>
        <div class="col-md-6">
            <label class="form-label"> Symbol</label>
            <div class="form-group">
                <select class="form-select shadow-none" [(ngModel)]="strategyParams.trading_symbol" (change)="onSymbolSelected(strategyParams)">
                    <option *ngFor="let sym of symbols" [disabled]="sym.disabled" [value]="sym.name"> {{ sym.name }}</option>
                </select>
            </div>
        </div>
    </div>
    <div class="row mt-2">
        <div class="col-md-4">
            <label class="form-label">Entry From</label>
            <div class="form-group">
                <input id="entry_time" type="time" class="form-control timer-size shadow-none" autocomplete="off" [(ngModel)]="strategyParams.entry_time" >
            </div>
        </div>
        <div class="col-md-4">
            <label class="form-label">Buffer/Entry To</label>
            <div class="form-group">
                <input type="time" class="form-control timer-size shadow-none" autocomplete="off" [(ngModel)]="strategyParams.buffer_time" >
            </div>
        </div>
        <div class="col-md-4">
            <label class="form-label">Exit Time</label>
            <div class="form-group">
                <input type="time" class="form-control timer-size shadow-none" autocomplete="off" [(ngModel)]="strategyParams.exit_time" >
            </div>
        </div>
    </div>
    <div class="row mt-1">
        <div class="invalid-feedback" [ngClass]="timeValueClass(strategyParams)">
            {{ strategyParams.time.err_msg }}
        </div>
    </div>
    <div class="row mt-2">
        <div class="col-md-6">
            <label class="form-label">Lots</label>
            <div class="form-group">
                <input type="number" step="1" min="1" (keypress)="numberOnly($event)" class="form-control shadow-none" [(ngModel)]="strategyParams.lots.value" required >
                <div class="invalid-feedback" [ngClass]="lotClass(strategyParams)">
                    Please provide atleast 1 Lot.
                </div>
            </div>
        </div>
        <div class="col-md-6">
            <label class="form-label">Interval</label>
            <div class="form-group">
                <div class="form-group">
                    <select class="form-select shadow-none" [(ngModel)]="strategyParams.selectedIntervalId" (change)="onIntervalChanged(strategyParams)">
                        <option *ngFor="let i of intervals" [value]="i._id"> {{ i.name }}</option>
                    </select>
                </div>
            </div>
        </div>
    </div>
    <div class="row mt-2">
        <div class="col-md-12">
            <label class="form-label">Strike Selection</label>
            <div class="input-group mb-3">
                <button class="btn btn-outline-secondary dropdown-toggle shadow-none" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                    {{ strategyParams.ss.segment_name }}
                </button>
                <ul class="dropdown-menu">
                  <li *ngFor="let sss of ss_segments">
                    <a class="dropdown-item" [ngClass]="sssClass(strategyParams, sss._id)" (click)="onSSSSelect(strategyParams, sss._id)">{{ sss.name }}</a>
                  </li>
                </ul>
                <button class="btn btn-outline-secondary dropdown-toggle shadow-none" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                    {{ strategyParams.ss.name }}
                </button>
                <ul class="dropdown-menu">
                    <li *ngFor="let sst of strategyParams.ss.types">
                        <a class="dropdown-item" [ngClass]="ssClass(strategyParams, sst._id)" (click)="onSSSelect(strategyParams, sst._id)">{{ sst.name }}</a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <div class="row ss-value-margin">
        <div class="col-md-12">
            <div class="input-group mb-3">
                <input type="number" class="form-control shadow-none" [(ngModel)]="strategyParams.ss.value.min" (keypress)="numberOnly($event)"
                [step]="strategyParams.ss.step" [min]="strategyParams.ss.min" [max]="strategyParams.ss.max"
                [placeholder]="strategyParams.ss.min_holder"aria-label="min number input for strike selection" >
                <input type="number" class="form-control shadow-none" [(ngModel)]="strategyParams.ss.value.max" (keypress)="numberOnly($event)"
                [step]="strategyParams.ss.step" [min]="strategyParams.ss.min" [max]="strategyParams.ss.max"
                [placeholder]="strategyParams.ss.max_holder" [disabled]="!strategyParams.ss.max_enabled"
                aria-label="max number input for strike selection" >
                <input type="number" class="form-control shadow-none" [(ngModel)]="strategyParams.ss.value.min_length" (keypress)="numberOnly($event)"
                [step]="strategyParams.ss.step_min_length" [min]="strategyParams.ss.min_min_length" [max]="strategyParams.ss.max_min_length"
                [placeholder]="strategyParams.ss.min_length_holder" [disabled]="!strategyParams.ss.min_length_enabled"
                aria-label="min length input for strike selection" >
                <input type="number" class="form-control shadow-none" [(ngModel)]="strategyParams.ss.value.max_length" (keypress)="numberOnly($event)"
                [step]="strategyParams.ss.step_max_length" [min]="strategyParams.ss.min_max_length" [max]="strategyParams.ss.max_max_length"
                [placeholder]="strategyParams.ss.max_length_holder" [disabled]="!strategyParams.ss.max_length_enabled"
                aria-label="max length number input for strike selection" >
                <div class="invalid-feedback" [ngClass]="ssValueClass(strategyParams)">
                    {{ strategyParams.ss.val_err_text }}.
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12">
            <label class="form-label">Reenter</label>
            <div class="input-group">
                <div class="input-group-text p-1">
                    <input class="form-check-input mt-0 shadow-none" type="checkbox"
                    [checked]="strategyParams.reenter.state == 'enabled'"
                    (change)="onReenterStateChanged(strategyParams, $event)" aria-label="Checkbox for Reenter"
                    >
                </div>
                <button class="btn btn-outline-secondary dropdown-toggle shadow-none"
                [disabled]="strategyParams.reenter.state == 'disabled'" type="button" data-bs-toggle="dropdown" 
                aria-expanded="false">
                    {{ strategyParams.reenter.on_text }}
                </button>
                <ul class="dropdown-menu">
                    <li *ngFor="let rtype of strategyParams.reenter.types">
                        <a class="dropdown-item" [ngClass]="reenterClass(strategyParams, rtype._id, 'on')" (click)="onReenterSelect(strategyParams, rtype._id)">{{ rtype.name }}</a>
                    </li>
                </ul>
                <button class="btn btn-outline-secondary dropdown-toggle shadow-none"
                [disabled]="strategyParams.reenter.state == 'disabled'" type="button" data-bs-toggle="dropdown" 
                aria-expanded="false">
                    {{ strategyParams.reenter.what_text }}
                </button>
                <ul class="dropdown-menu">
                    <li *ngFor="let wtype of strategyParams.reenter.whats">
                        <a class="dropdown-item" [ngClass]="reenterClass(strategyParams, wtype._id, 'what')" (click)="onReenterWhatSelect(strategyParams, wtype._id)">{{ wtype.name }}</a>
                    </li>
                </ul>
                <input type="number" min="-1" step="1" max="100" class="form-control shadow-none"
                [(ngModel)]="strategyParams.reenter.count" aria-label="Text input for reenter"
                [disabled]="strategyParams.reenter.state == 'disabled'"
                >
                <button class="btn btn-outline-secondary dropdown-toggle shadow-none"
                [disabled]="strategyParams.reenter.state == 'disabled'" type="button" data-bs-toggle="dropdown" 
                aria-expanded="false">
                    {{ strategyParams.reenter.freq_text }}
                </button>
                <ul class="dropdown-menu">
                    <li *ngFor="let ftype of strategyParams.reenter.freqs">
                        <a class="dropdown-item" [ngClass]="reenterClass(strategyParams, ftype._id, 'freq')" (click)="onReenterFreqSelect(strategyParams, ftype._id)">{{ ftype.name }}</a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <div class="row mt-4">
        <div class="col-md-6 text-center pt-1">
            <div class="btn-group btn-group-sm" role="group">
                <input type="radio" class="btn-check" name="btnradio" id="btnPaper" autocomplete="off"
                [checked]="strategyParams.run_mode.which == 'paper'" (click)="onModeSelect(strategyParams, 'paper')"
                >
                <label class="btn shadow-none" for="btnPaper" [ngClass]="modeClass(strategyParams, 'paper')">PAPER</label>
                <input type="radio" class="btn-check" name="btnradio" id="btnDryrun" autocomplete="off"
                [checked]="strategyParams.run_mode.which == 'dry_run'" (click)="onModeSelect(strategyParams, 'dry_run')"
                >
                <label class="btn shadow-none" for="btnDryrun" [ngClass]="modeClass(strategyParams, 'dry_run')">DRYRUN</label>
                <input type="radio" class="btn-check" name="btnradio" id="btnLive" autocomplete="off"
                [checked]="strategyParams.run_mode.which == 'live'" (click)="onModeSelect(strategyParams, 'live')"
                >
                <label class="btn shadow-none" for="btnLive" [ngClass]="modeClass(strategyParams, 'live')">LIVE</label>
            </div>
        </div>
        <div class="col-md-6">
            <!-- <label class="form-label">Lots</label> -->
            <div class="input-group">
                <button class="btn btn-outline-secondary dropdown-toggle shadow-none" type="button"
                data-bs-toggle="dropdown" aria-expanded="false" [disabled]="strategyParams.run_mode.which != 'paper'">
                    {{ strategyParams.run_mode.value.telegram_source_text }}
                </button>
                <ul class="dropdown-menu">
                    <li *ngFor="let rtype of strategyParams.run_mode.types">
                        <a class="dropdown-item" [ngClass]="alertSourceClass(strategyParams, rtype._id)" (click)="onAlertSourceSelected(strategyParams, rtype._id)">{{ rtype.name }}</a>
                    </li>
                </ul>
                <input type="text" placeholder="Telegram ID" class="form-control shadow-none"
                [(ngModel)]="strategyParams.run_mode.value.telegram_id" required
                [disabled]="strategyParams.run_mode.which != 'paper'">
            </div>
            <!-- <div class="input-group" [disabled]="strategyParams.run_mode.which != 'paper'">
                <button class="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false">
                    {{ strategyParams.run_mode.value.telegram_source_text }}
                </button>
                <ul class="dropdown-menu">
                    <li *ngFor="let rtype of strategyParams.run_mode.types">
                        <a class="dropdown-item" [ngClass]="alertSourceClass(strategyParams, rtype._id, 'on')" (click)="onAlertSourceSelected(strategyParams, rtype._id)">{{ rtype.name }}</a>
                    </li>
                </ul>
                <input type="text" placeholder="Telegram ID" class="form-control shadow-none"
                [(ngModel)]="strategyParams.run_mode.value.telegram_id" required>
            </div> -->
            <div class="invalid-feedback" [ngClass]="lotClass(strategyParams)">
                Please provide Telegram ID.
            </div>
        </div>
    </div>
    <div class="row mt-3">
        <div class="col-md-12 d-flex align-items-end justify-content-evenly">
            <div class="btn-group btn-group-sm" role="group">
                <input type="radio" class="btn-check" name="btnradio" id="btnBuy" autocomplete="off"
                [checked]="strategyParams.tt == 'buy'" (click)="onTTSelect(strategyParams, 'buy')"
                >
                <label class="btn shadow-none" for="btnBuy" [ngClass]="ttClass(strategyParams, 'buy')">BUY</label>
                <input type="radio" class="btn-check" name="btnradio" id="btnSell" autocomplete="off"
                [checked]="strategyParams.tt == 'sell'" (click)="onTTSelect(strategyParams, 'sell')"
                >
                <label class="btn shadow-none" for="btnSell" [ngClass]="ttClass(strategyParams, 'sell')">SELL</label>
            </div>
            <div class="btn-group btn-group-sm" role="group">
                <input type="radio" class="btn-check" name="btnradio" id="btnMis" autocomplete="off"
                [checked]="strategyParams.pt == 'mis'" (click)="onPTSelect(strategyParams, 'mis')"
                >
                <label class="btn shadow-none" for="btnMis" [ngClass]="ptClass(strategyParams, 'mis')">MIS</label>
                <input type="radio" class="btn-check" name="btnradio" id="btnNrml" autocomplete="off"
                [checked]="strategyParams.pt == 'nrml'" (click)="onPTSelect(strategyParams, 'nrml')"
                >
                <label class="btn shadow-none" for="btnNrml" [ngClass]="ptClass(strategyParams, 'nrml')">NRML</label>
            </div>
        </div>
    </div>
    <div class="row mt-4">
        <div class="input-group mb-3">
            <div class="input-group-text bg-transparent">
                <input class="form-check-input mt-0 shadow-none" type="checkbox" 
                [checked]="strategyParams.tgt.state == 'enabled'"
                (change)="onSLTgtCheckChange(strategyParams, $event, 'tgt')"
                aria-label="Checkbox for following text input"
                >
            </div>
            <a class="btn bg-transparent border border-start-0 flex-fill"
            [attr.data-bs-toggle]="strategyParams.tgt.content" data-bs-target="#collapseTgt" type="button"
            [ngClass]="slTgtClass(strategyParams, 'tgt')" (click)="onSLTgtPanelClick(strategyParams, 'tgt')"
            aria-expanded="false" aria-controls="collapseTgt">Target</a>
            <span class="input-group-text bg-transparent border border-start-0"
            [attr.data-bs-toggle]="strategyParams.tgt.content" data-bs-target="#collapseTgt"
            (click)="onSLTgtPanelClick(strategyParams, 'tgt')">
                <i class="bi bi-chevron-down" [ngClass]="slTgtClass(strategyParams, 'tgt')"></i>
            </span>
        </div>
    </div>
    <div class="collapse row mt-2" id="collapseTgt">
        <div class="col">
            <div class="input-group mb-3">
                <div class="input-group-prepend d-flex">
                    <div class="input-group-text rounded-0">
                        <input class="form-check-input mt-0 shadow-none" type="checkbox" 
                        [checked]="strategyParams.tgt.state == 'enabled'"
                        (change)="onSLTgtCheckChange(strategyParams, $event, 'tgt')"
                        aria-label="Checkbox for following text input"
                        >
                        <span class="ms-2">Leg</span>
                    </div>
                    <button class="btn btn-outline-secondary dropdown-toggle form-control rounded-0 shadow-none" type="button"
                    data-bs-toggle="dropdown" aria-expanded="false" [ngClass]="slTgtErrTypeClass(strategyParams, 'tgt_type')">
                        {{ strategyParams.tgt.type_text }}
                    </button>
                    <ul class="dropdown-menu">
                        <li *ngFor="let tgt_type of strategyParams.tgt.types"><a class="dropdown-item" [ngClass]="slTgtTypeClass(strategyParams, tgt_type._id, 'tgt_type')"
                            (click)="onSLTgtTypeSelect(strategyParams, tgt_type._id, 'tgt_type')">{{ tgt_type.name }}</a>
                        </li>
                    </ul>
                    <button class="btn btn-outline-secondary dropdown-toggle form-control rounded-0 shadow-none" type="button"
                    data-bs-toggle="dropdown" aria-expanded="false" [ngClass]="slTgtErrTypeClass(strategyParams, 'tgt_value_type')">
                        {{ strategyParams.tgt.value_type_text }}
                    </button>
                    <ul class="dropdown-menu">
                        <li *ngFor="let tgt_value_type of strategyParams.tgt.value_types"><a class="dropdown-item" [ngClass]="slTgtTypeClass(strategyParams, tgt_value_type._id, 'tgt_value_type')"
                            (click)="onSLTgtTypeSelect(strategyParams, tgt_value_type._id, 'tgt_value_type')">{{ tgt_value_type.name }}</a>
                        </li>
                    </ul>
                </div>
                <input type="number" class="form-control txt-al-center shadow-none" [(ngModel)]="strategyParams.tgt.value"
                step="0.1" min="1" aria-label="number input for target value"
                [ngClass]="slTgtErrValueClass(strategyParams, 'tgt')">
            </div>
        </div>
    </div>
    <div class="row mt-2">
        <div class="input-group mb-3">
            <div class="input-group-text bg-transparent">
                <input class="form-check-input mt-0 shadow-none" type="checkbox"
                [checked]="strategyParams.sl.state == 'enabled'"
                (change)="onSLTgtCheckChange(strategyParams, $event, 'sl')"
                aria-label="Checkbox for following text input">
            </div>
            <a class="btn bg-transparent border border-start-0 flex-fill"
            [attr.data-bs-toggle]="strategyParams.sl.content" data-bs-target="#collapseSL" type="button"
            [ngClass]="slTgtClass(strategyParams, 'sl')" (click)="onSLTgtPanelClick(strategyParams, 'sl')"
            aria-expanded="false" aria-controls="collapseSL">SL</a>
            <span class="input-group-text bg-transparent border border-start-0"
            [attr.data-bs-toggle]="strategyParams.sl.content" data-bs-target="#collapseSL"
            (click)="onSLTgtPanelClick(strategyParams, 'sl')">
                <i class="bi bi-chevron-down" [ngClass]="slTgtClass(strategyParams, 'sl')"></i>
            </span>
        </div>
    </div>
    <div class="collapse row mt-2" id="collapseSL">
        <div class="col">
            <div class="input-group mb-3">
                <div class="input-group-prepend d-flex">
                    <div class="input-group-text rounded-0">
                        <input class="form-check-input mt-0 shadow-none" type="checkbox" 
                        [checked]="strategyParams.sl.state == 'enabled'"
                        (change)="onSLTgtCheckChange(strategyParams, $event, 'sl')"
                        aria-label="Checkbox for following text input"
                        >
                        <span class="ms-2">Leg</span>
                    </div>
                    <button class="btn btn-outline-secondary dropdown-toggle form-control rounded-0 shadow-none" type="button"
                    data-bs-toggle="dropdown" aria-expanded="false" [ngClass]="slTgtErrTypeClass(strategyParams, 'sl_type')">
                        {{ strategyParams.sl.type_text }}
                    </button>
                    <ul class="dropdown-menu">
                        <li *ngFor="let sl_type of strategyParams.sl.types">
                            <a class="dropdown-item" [ngClass]="slTgtTypeClass(strategyParams, sl_type._id, 'sl_type')"
                                (click)="onSLTgtTypeSelect(strategyParams, sl_type._id, 'sl_type')">{{ sl_type.name }}
                            </a>
                        </li>
                    </ul>
                    <button class="btn btn-outline-secondary dropdown-toggle form-control rounded-0 shadow-none" type="button"
                    data-bs-toggle="dropdown" aria-expanded="false" [ngClass]="slTgtErrTypeClass(strategyParams, 'sl_value_type')">
                        {{ strategyParams.sl.value_type_text }}
                    </button>
                    <ul class="dropdown-menu">
                        <li *ngFor="let sl_value_type of strategyParams.sl.value_types">
                            <a class="dropdown-item" [ngClass]="slTgtTypeClass(strategyParams, sl_value_type._id, 'sl_value_type')"
                            (click)="onSLTgtTypeSelect(strategyParams, sl_value_type._id, 'sl_value_type')">{{ sl_value_type.name }}</a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="input-group mb-3">
                <div class="input-group-prepend d-flex">
                    <input type="number" class="form-control txt-al-center shadow-none" [(ngModel)]="strategyParams.sl.value"
                    step="0.1" min="strategyParams.sl.min" aria-label="number input for SL value"
                    [ngClass]="slTgtErrValueClass(strategyParams, 'sl')">
                    <input type="number" class="form-control txt-al-center shadow-none" [(ngModel)]="strategyParams.sl.min_value"
                    step="0.1" min="strategyParams.sl.min" aria-label="number input for SL Min value"
                    [ngClass]="slTgtErrValueClass(strategyParams, 'sl')" [disabled]="!strategyParams.sl.min_enabled">
                    <input type="number" class="form-control txt-al-center shadow-none" [(ngModel)]="strategyParams.sl.max_value"
                    step="0.1" min="strategyParams.sl.min" aria-label="number input for SL Max value2"
                    [ngClass]="slTgtErrValueClass(strategyParams, 'sl')" [disabled]="!strategyParams.sl.max_enabled">
                </div>
            </div>
        </div>
    </div>
    <div class="row mt-2">
        <div class="input-group mb-3">
            <div class="input-group-text bg-transparent">
                <input class="form-check-input mt-0 shadow-none" type="checkbox"
                [checked]="strategyParams.tsl.state == 'enabled'" [disabled]="strategyParams.sl.state == 'disabled'"
                (change)="onSLTgtCheckChange(strategyParams, $event, 'tsl')"
                aria-label="Checkbox for following text input" >
            </div>
            <a class="btn bg-transparent border border-start-0 flex-fill"
            [attr.data-bs-toggle]="strategyParams.tsl.content" data-bs-target="#collapseTSL" type="button"
            [ngClass]="slTgtClass(strategyParams, 'tsl')" (click)="onSLTgtPanelClick(strategyParams, 'tsl')"
            aria-expanded="false" aria-controls="collapseTSL">TSL
                <!-- <button type="button" class="btn btn-sm" data-bs-toggle="popover" data-bs-content="TSL can be enabled only if SL is enabled."> -->
                    <!-- <i tabindex="0" class="btn bi bi-info text-primary info-icon" role="button" data-bs-toggle="popover" data-bs-content="zz"></i> -->
                <!-- </button> -->
            </a>
            <span class="input-group-text bg-transparent border border-start-0"
            [attr.data-bs-toggle]="strategyParams.tsl.content" data-bs-target="#collapseTSL"
            (click)="onSLTgtPanelClick(strategyParams, 'tsl')">
                <i class="bi bi-chevron-down" [ngClass]="slTgtClass(strategyParams, 'tsl')"></i>
            </span>
        </div>
    </div>
    <div class="collapse row mt-2" id="collapseTSL">
        <div class="col-md-9">
            <div class="input-group">
                <button class="btn btn-outline-secondary dropdown-toggle form-control shadow-none"
                type="button" data-bs-toggle="dropdown" 
                aria-expanded="false"  [ngClass]="slTgtErrTypeClass(strategyParams, 'tsl')">
                    {{ strategyParams.tsl.type_text }}
                </button>
                <ul class="dropdown-menu">
                    <li><a class="dropdown-item" [ngClass]="slTgtTypeClass(strategyParams, 'pts', 'tsl')"
                        (click)="onSLTgtTypeSelect(strategyParams, 'pts', 'tsl')">Points</a></li>
                    <li><a class="dropdown-item" [ngClass]="slTgtTypeClass(strategyParams, 'percent', 'tsl')"
                        (click)="onSLTgtTypeSelect(strategyParams, 'percent', 'tsl')">Percent</a></li>
                </ul>
                <input type="number" min="1" step="1" max="100" class="form-control txt-al-center shadow-none"
                [(ngModel)]="strategyParams.tsl.sl" aria-label="Number input for TSL"
                [disabled]="strategyParams.tsl.state == 'disabled'" [ngClass]="slTgtErrValueClass(strategyParams, 'tslv')">
                <input type="number" min="1" step="1" max="100" class="form-control txt-al-center shadow-none"
                [(ngModel)]="strategyParams.tsl.range" aria-label="Number input for TSL"
                [disabled]="strategyParams.tsl.state == 'disabled'" [ngClass]="slTgtErrValueClass(strategyParams, 'tslr')">
            </div>
            <div class="invalid-feedback" [ngClass]="tslValueClass(strategyParams)">
                SL Value should be lesser than trail range value.
            </div>
        </div>
        <div class="col-md-3">
            <input class="form-check-input mt-0 shadow-none" type="checkbox" 
            [checked]="strategyParams.tsl.ctc == 1"
            (change)="onTSLCTCCheckChange(strategyParams, $event)"
            aria-label="Checkbox for following text input" >
            <span>CTC</span>
        </div>
    </div>
    <div class="row mt-2">
        <div class="input-group mb-3">
            <div class="input-group-text bg-transparent">
                <input class="form-check-input mt-0 shadow-none" type="checkbox" 
                [checked]="strategyParams.order_adjustment.state == 'enabled'"
                [disabled]="strategyParams.tgt.state == 'disabled' || strategyParams.sl.state == 'disabled'"
                (change)="onSLTgtCheckChange(strategyParams, $event, 'order_adjustment')"
                aria-label="Checkbox for following text input"
                >
            </div>
            <a class="btn bg-transparent border border-start-0 flex-fill"
            [attr.data-bs-toggle]="strategyParams.order_adjustment.content" data-bs-target="#collapseOrderAdjustment" type="button"
            [ngClass]="slTgtClass(strategyParams, 'order_adjustment')" (click)="onSLTgtPanelClick(strategyParams, 'order_adjustment')"
            aria-expanded="false" aria-controls="collapseTgt">Order Adjustment</a>
            <span class="input-group-text bg-transparent border border-start-0"
            [attr.data-bs-toggle]="strategyParams.order_adjustment.content" data-bs-target="#collapseOrderAdjustment"
            (click)="onSLTgtPanelClick(strategyParams, 'order_adjustment')">
                <i class="bi bi-chevron-down" [ngClass]="slTgtClass(strategyParams, 'order_adjustment')"></i>
            </span>
        </div>
    </div>
    <div class="collapse row mt-2" id="collapseOrderAdjustment">
        <div class="col">
            <div class="input-group mb-3">
                <div class="input-group-prepend d-flex">
                    <div class="input-group-text rounded-0">
                        <input class="form-check-input mt-0 shadow-none" type="checkbox" 
                        [checked]="strategyParams.order_adjustment.sl.state == 'enabled'"
                        (change)="onSLTgtCheckChange(strategyParams, $event, 'order_adjustment_sl')"
                        aria-label="Checkbox for following text input"
                        >
                        <span class="ms-2">SL</span>
                    </div>
                    <button class="btn btn-outline-secondary dropdown-toggle form-control rounded-0 shadow-none" type="button"
                    data-bs-toggle="dropdown" aria-expanded="false" [ngClass]="slTgtErrTypeClass(strategyParams, 'order_adjustment_sl')">
                        {{ strategyParams.order_adjustment.sl.type_text }}
                    </button>
                    <ul class="dropdown-menu">
                        <li><a class="dropdown-item" [ngClass]="slTgtTypeClass(strategyParams, 'pts', 'order_adjustment_sl')" (click)="onSLTgtTypeSelect(strategyParams, 'pts', 'order_adjustment_sl')">Points</a></li>
                        <li><a class="dropdown-item" [ngClass]="slTgtTypeClass(strategyParams, 'percent', 'order_adjustment_sl')" (click)="onSLTgtTypeSelect(strategyParams, 'percent', 'order_adjustment_sl')">Percent</a></li>
                    </ul>
                </div>
                <input type="number" class="form-control txt-al-center shadow-none" [(ngModel)]="strategyParams.order_adjustment.sl.value"
                step="0.1" min="1" aria-label="number input for target value"
                [ngClass]="slTgtErrValueClass(strategyParams, 'order_adjustment_sl')">
            </div>
            <div class="input-group mb-3">
                <div class="input-group-prepend d-flex">
                    <div class="input-group-text rounded-0">
                        <input class="form-check-input mt-0 shadow-none" type="checkbox" 
                        [checked]="strategyParams.order_adjustment.tgt.state == 'enabled'"
                        (change)="onSLTgtCheckChange(strategyParams, $event, 'order_adjustment_tgt')"
                        aria-label="Checkbox for following text input"
                        >
                        <span class="ms-2">Target</span>
                    </div>
                    <button class="btn btn-outline-secondary dropdown-toggle form-control rounded-0 shadow-none" type="button"
                    data-bs-toggle="dropdown" aria-expanded="false" [ngClass]="slTgtErrTypeClass(strategyParams, 'order_adjustment_tgt')">
                        {{ strategyParams.order_adjustment.tgt.type_text }}
                    </button>
                    <ul class="dropdown-menu">
                        <li><a class="dropdown-item" [ngClass]="slTgtTypeClass(strategyParams, 'pts', 'order_adjustment_tgt')" (click)="onSLTgtTypeSelect(strategyParams, 'pts', 'order_adjustment_tgt')">Points</a></li>
                        <li><a class="dropdown-item" [ngClass]="slTgtTypeClass(strategyParams, 'percent', 'order_adjustment_tgt')" (click)="onSLTgtTypeSelect(strategyParams, 'percent', 'order_adjustment_tgt')">Percent</a></li>
                    </ul>
                </div>
                <input type="number" class="form-control txt-al-center shadow-none" [(ngModel)]="strategyParams.order_adjustment.tgt.value"
                step="0.1" min="1" aria-label="number input for target value"
                [ngClass]="slTgtErrValueClass(strategyParams, 'order_adjustment_tgt')">
            </div>
        </div>
    </div>
    <div class="row mt-4">
        <div class="col-md-auto pe-0" *ngFor="let d of days">
            <div class="input-group flex-nowrap">
                <div class="input-group-prepend">
                    <div class="input-group-text d-block p-1 border-0 bg-white">
                        <input type="checkbox" aria-label="Checkbox for days" [(ngModel)]="strategyParams.days[d]"
                        >
                    </div>
                </div>
                <span class="input-group-text flex-nowrap p-1 border-0 bg-white">{{ d }}</span>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12">
            <label class="form-label">&nbsp;</label>
        </div>
    </div>
</div>
